import { Gender } from "../../../../common/interfaces/enums/Gender";
import { SmokerStatus } from "../../../../common/interfaces/enums/SmokerStatus";
import IApiClient from "../../../interfaces/api/group/case/config/clients/IApiClient";
import { IClient } from "../../../../common/interfaces/IClient";
import ISettingClient from "../../../../common/interfaces/settings/clients/ISettingClient";
import { IQuoteSettingsContainerBase } from "../../../../common/interfaces/settings/IQuoteSettingsContainerBase";

const mapLocalClientToRemote = (client: IClient): IApiClient => {
    return {
        age: client.age,
        isSmoker: client.smokerStatus === SmokerStatus.Smoker,
        gender: client.gender || Gender.Unknown,
        isChild: client.isChild,
        personId: client.personId || 0,
        number: 0
    };
};

const mapRemoteClientToLocal = (client: IApiClient): ISettingClient => {
    return {
        isSelected: true,
        personId: client.personId
    };
};

export const Client = {
    localToRemote: mapLocalClientToRemote,
    remoteToLocal: mapRemoteClientToLocal
};

export function getAllSelectedClientsIds(
    settings: IQuoteSettingsContainerBase
): number[] {
    return settings.clients.filter((c) => c.isSelected).map((c) => c.personId);
}
